module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('p', {
    staticClass: "navbar-text",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("Logado como: "), _c('span', {
    staticClass: "label label-default"
  }, [_vm._v(" " + _vm._s(_vm.nome) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group ",
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filialSel),
      expression: "filialSel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "UnidadeLuandre",
      "id": "UnidadeLuandre"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filialSel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.mudouLuandre]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecione...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Matriz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("ABC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Alphaville")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Campinas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Curitiba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Faria Lima")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Guarulhos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Jundiaí")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Recife")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Rio de Janeiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Santo Amaro")])])])]), _vm._v(" "), _c('li', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.permissaoBotaoEspontaneo),
      expression: "permissaoBotaoEspontaneo"
    }],
    staticClass: "btn btn-info",
    staticStyle: {
      "margin": "0 0 0 12px"
    },
    attrs: {
      "type": "button",
      "title": "Espontâneo"
    },
    on: {
      "click": _vm.espontaneo
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin": "8px 8px 8px 3px"
    },
    attrs: {
      "type": "button",
      "title": "Lista de Ramais da Intranet"
    },
    on: {
      "click": _vm.ramais
    }
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "margin": "8px 0px 8px -4px"
    },
    attrs: {
      "type": "button",
      "title": "Logout"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal zoom ",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modalRamais"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content text-left"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('v-select', {
    attrs: {
      "value": "Chave",
      "label": "Valor",
      "options": _vm.listaColaboradores
    },
    on: {
      "change": function($event) {
        return _vm.buscar()
      }
    },
    model: {
      value: (_vm.colaborador),
      callback: function($$v) {
        _vm.colaborador = $$v
      },
      expression: "colaborador"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.buscar()
      }
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('Espontaneo')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/agenda"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/luandre.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('small', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v(" FastRH | Módulo Administrativo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/agenda"
    }
  }, [_vm._v("Agenda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/recepcao"
    }
  }, [_vm._v("Recepção")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/estoque"
    }
  }, [_vm._v("Estoque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/configuracoes"
    }
  }, [_vm._v("Configurações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/dashboard"
    }
  }, [_vm._v("Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://fastrhluandre.com.br"
    }
  }, [_vm._v("FastRH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("Ramais da Intranet ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7e159cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/navbar/Navbar.vue
// module id = 305
// module chunks = 1